import React from "react";
import { formatCountString } from "web/react/components/feed-count/feed-count";
import { BreadcrumbPills } from "web/react/components/feeds-filters/feeds-filter-breadcrumb-pills/feeds-filter-breadcrumb-pills";
import {
    PaginatedItem,
    PaginationExpansionState,
    PaginationState,
} from "web/react/components/feeds-filters/feeds-filters-pagination/pagination-state";
import { getSelectedOptions } from "web/react/components/feeds-filters/hooks/use-filter-manager";
import { Text } from "web/react/emo/text";
import withReduxProvider from "web/react/redux-provider";
import { gettext, ngettext } from "web/script/modules/django-i18n";
import { AllSelectedFilterInfo, FilterClickHandler } from "web/types/feed-filters";
import * as styles from "./filter-applied-filters.css";

interface FilterAppliedFiltersProps {
    selectedFilterInfo: AllSelectedFilterInfo;
    onClick: FilterClickHandler;
    paginationState: PaginationState;
    onClose: (item: PaginatedItem) => void;
    count: number;
}

export function FilterAppliedFilters({
    selectedFilterInfo,
    onClick,
    paginationState,
    onClose,
    count,
}: FilterAppliedFiltersProps): JSX.Element {
    let selectedOptions = getSelectedOptions(selectedFilterInfo);
    const breadcrumbs = selectedOptions.map((option) => ({
        id: `${option.name}=${option.value}`,
        to: option.url,
        label: option.label,
        onClick: () => onBreadcrumbPillClick(option, true),
        hideIcon: option.name === "gender" && option.value === "all",
    }));

    function onBreadcrumbPillClick(item, immediateUnselect): void {
        onClick(item, immediateUnselect);
        if (paginationState.getExpansionState(item) !== PaginationExpansionState.Collapsed) {
            onClose(item);
        }
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.content} data-testid="applied-filters">
                <Text className={styles.label} textStyle={"caption-1"} as={"p"}>
                    {
                        // "Applied filters"
                        `${gettext("feed.filters.applied_filters_label")}:`
                    }
                </Text>
                <BreadcrumbPills breadcrumbs={breadcrumbs} />
                <Text className={styles.count} textStyle="footnote">
                    {
                        // "Result: {count} item"
                        // "Result: {count} items"
                        ngettext(
                            "feed.items_count_results.label",
                            "feed.items_count_results.label_pl",
                            count,
                            {
                                count: formatCountString(count),
                            }
                        )
                    }
                </Text>
            </div>
        </div>
    );
}

export default withReduxProvider(FilterAppliedFilters);
